let API_ROUTE = "";
if (
  process.env.REACT_APP_ENV === "local" ||
  process.env.NODE_ENV === "development"
) {
  API_ROUTE = "http://localhost:3002/api/v1/";
}
if (process.env.REACT_APP_ENV === "qa") {
  API_ROUTE = "https://reservasdev.estig.ipb.pt/api/v1/";
}
if (process.env.REACT_APP_ENV === "production") {
  API_ROUTE = "https://reservas.ipb.pt/api/v1/";
}

export default API_ROUTE;
